import { render, staticRenderFns } from "./MJVideo.vue?vue&type=template&id=00ab69b7&scoped=true"
import script from "./MJVideo.vue?vue&type=script&lang=js"
export * from "./MJVideo.vue?vue&type=script&lang=js"
import style0 from "./MJVideo.vue?vue&type=style&index=0&id=00ab69b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_85bb6ef93cf5a779f9b064f420832c70/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ab69b7",
  null
  
)

export default component.exports